import styled from 'styled-components'

import { device, DEVICE_SIZE } from '@util/breakpoints'
import { spacing } from '@util/spacing'

const NavHeight = spacing.s64

export const Nav = styled.nav`
  height: ${NavHeight};
  display: flex;
  justify-content: center;
  margin-bottom: 0;
  padding: 0 ${spacing.s16};
  border-bottom: 2px solid #f3f3f3;
`

export const NavInnerWrapperLeft = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  float: left;
  height: ${NavHeight};
`

export const NavInnerWrapperRight = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: ${NavHeight};
`


export const NavInnerWrapperCenter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  -webkit-transition: .3s ease-out;
  -moz-transition: .3s ease-out;
  -o-transition: .3s ease-out;
  transition: .3s ease-out;
`

export const LogoWrapper = styled.a`
  text-align: center;
`

type AltNavProps = {
  background?: string
}

export const AltNav = styled.nav<AltNavProps>`
  background: ${(props) => props.background || '#fff'};
  display: flex;
  justify-content: center;
  border-bottom: 2px solid #f3f3f3;
  height: 7.5rem;
  padding: 1em 0.625rem;

  @media ${device.tablet} {
    height: ${spacing.s240};
    padding: 2em 0.625rem;
  }
`

export const AltNavInnerWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 ${spacing.s8};
  width: 100%;

  @media ${device.tablet} {
    width: ${DEVICE_SIZE.tablet};
    padding: 0 5.625rem;
    align-items: flex-start;
  }

  @media ${device.desktopM} {
    width: ${DEVICE_SIZE.desktopM};
  }

  @media ${device.desktop} {
    width: ${DEVICE_SIZE.desktop};
  }
`

export const AltNavLinkWrapper = styled.div`
  a {
    color: #fff;
  }
`

export const SalesforceLogo = styled.img`
  width: 194px;
  height: 88px;

  @media ${device.tablet} {
    width: 388px;
    height: 176px;
  }
`

export const MastercardLogo = styled.img`
  width: 200px;

  @media ${device.tablet} {
    width: 400px;
    padding: ${spacing.s48} 0;
  }
`

export const LanguageSwitcherWrapper = styled.div`
  width: 100%;
  max-width: ${spacing.s224};
  margin-right: ${spacing.s24}; 
`
